import React from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import ATTextButton from '../formComponent/ATTextButton'

interface ATConfirmBoxProps {
  showModal: boolean
  modalTitle: string
  modalMessage: string
  onSave: () => void
  onCancel: () => void
  saveLabel?: string
  cancelLabel?: string
}
const ATConfirmBox: React.FC<ATConfirmBoxProps> = ({
  showModal,
  modalTitle,
  modalMessage,
  onSave,
  onCancel,
  saveLabel,
  cancelLabel,
}: ATConfirmBoxProps) => {
  const { t } = useTranslation(['translation'])
  return (
    <Modal
      className="modal"
      backdrop="static"
      show={showModal}
      onHide={onCancel}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          {modalTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{modalMessage}</Modal.Body>
      <Modal.Footer>
        <ATTextButton
          title={t(cancelLabel ?? 'common.cancel')}
          onPressHandler={onCancel}
          isFilledButton={false}
        />
        <ATTextButton
          title={t(saveLabel ?? 'common.confirm').toUpperCase()}
          onPressHandler={onSave}
          isFilledButton={true}
        />
      </Modal.Footer>
    </Modal>
  )
}
export default ATConfirmBox
